import { useEffect } from 'react'

import { useCADPageStore } from '@/state/cad'
import type { GLTFObject } from '@/lib/cad/GLTFObject'

export const useExplosionLines = (gltf?: GLTFObject) => {
  const explosionsState = useCADPageStore((state) => state.explosionsState)
  const explosions = useCADPageStore((state) => state.explosions)
  const hiddenParts = useCADPageStore((state) => state.hiddenParts)
  const isExplosionLinesEnabled = useCADPageStore(
    (state) => state.isExplosionLinesEnabled,
  )

  useEffect(() => {
    if (gltf) {
      gltf.showExplosionLines(explosions, isExplosionLinesEnabled, {
        hiddenParts,
      })
    }
  }, [gltf, explosions, isExplosionLinesEnabled, hiddenParts, explosionsState])
}
